import React from 'react';

export const SwapContext = React.createContext();
export const SwapContextProvider = SwapContext.Provider;